import styled from 'styled-components';


export const Container = styled.div`
  width: 97%;
  display: flex;

  .auto_complete_wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .auto_complete_button {
    gap: 10px;
    width: 88px;

    height: 56px;
    border: none;
    
    display: flex;
    padding: 10px;
    z-index: 1;
    
    flex-shrink: 0;
    cursor: pointer;
    border-radius: 4px;
    
    margin: 0 0 0 1rem;
    align-items: center;
    
    justify-content: center;
  }

  .order_date_wrapper {
    display: flex;
    margin: 0 0 0 2.9rem;
    position: relative;
    z-index: 999999;
    .down {
      height: 60px;
      display: flex;
      padding: 1rem;
      cursor: pointer;
      border-radius: 8px;
      align-items: center;
      justify-content: center;
      background: ${({ theme }) => theme.colors.order_buttons};
    }

    .up {
      height: 60px;
      display: flex;
      padding: 1rem;
      margin: 0 1rem;
      cursor: pointer;
      border-radius: 8px;
      align-items: center;
      justify-content: center;
      background: ${({ theme }) => theme.colors.order_buttons};
    }
  
    .alpha {
      height: 60px;
      display: flex;
      padding: 1rem;
      cursor: pointer;
      border-radius: 8px;
      align-items: center;
      margin: 0 0 0 2.7rem;
      justify-content: center;
      background: ${({ theme }) => theme.colors.order_buttons};
    }

  }

  @media(max-width:820px) {
    width: 100%;
    display: block;
    margin: 0 -3rem 0 0;

    .auto_complete_wrapper {
      margin-left: 0;
      justify-content: space-between;
    }

    .auto_complete_button {
      width: 55px;
    }

    .order_date_wrapper {
      justify-content: flex-start;

      .alpha {
        margin: 0 1rem 0 1.7rem;
      }
    }
    
  }

  @media(max-width: 420px) {
    .order_date_wrapper {
      margin: 1rem 0 0 0;
      justify-content: space-between;

      .down {
        margin: 0;
      }

      .up {
        margin: 0 10px;
      }
    }

  }

  @media(max-width: 540px) {
    .order_date_wrapper {
      margin: 1rem 3rem 0 0;
      justify-content: space-between;

      .down {
        margin: 0;
      }

      .up {
        margin: 0 10px;
      }
    }

  }
`;

export const MobileFilterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0 2rem 0 0;

  @media screen and (min-width: 541px) and (max-width: 820px) {
    justify-content: center;
    margin: 1rem 2rem 0 0;
  }
`;



